import { BaseService } from '../base/service';
import { EmptyService } from './emptyService';
import { TextService } from './textService';

export function createTextEmptyService(textService: TextService): EmptyService {
  return new TextEmptyService(textService);
}

class TextEmptyService extends BaseService implements EmptyService {
  constructor(textService: TextService) {
    super(textService);

    this.textService = textService;
  }

  private readonly textService: TextService;

  get isEmpty() {
    return this.textService.text.length === 0;
  }
}
